/**
 * Top Bar
 * - Fetch users geolocation and display relevant text
 * - Store user country code in local storage to prevent repeat API calls
 *
 * @author Matt <matt@joipolloi.com>
 * @package Minifigs 2.0
 */

import { euCountries } from '../../util/euCountryList';

const topBar = () => {
    const topBarAlert = document.getElementById('topBarAlert');
    const topBarAlertTexts = Array.from(document.querySelectorAll('.topBarAlert--text'));
    const topBarAlertDefault = document.querySelector('.topBarAlert--default');
    if (!topBarAlert || !topBarAlertTexts || !topBarAlertDefault) return;

    const displayText = (countryCode) => {
        if (topBarAlertTexts.length > 0) {
            topBarAlertTexts.map((text) => {
                if (text.dataset.countrycode === countryCode) {
                    text.style.display = 'block';
                    topBarAlertDefault.style.display = 'none';
                    topBarAlert.classList.add(`active--${countryCode}`);
                }
            });
        }
    };

    const userCountry = localStorage.getItem('user_country');
    if (userCountry) {
        displayText(userCountry);
    } else {
        fetch('https://api.ipregistry.co/?key=u9b0sa4ypuwudqha')
            .then((response) => response.json())
            .then((data) => data.location.country.code)
            .then((countryCode) => {
                if (euCountries.includes(countryCode)) {
                    displayText('EU');
                    localStorage.setItem('user_country', 'EU');
                } else {
                    displayText(countryCode);
                    localStorage.setItem('user_country', countryCode);
                }
            });
    }
};

export default topBar;


document.addEventListener("DOMContentLoaded", () => {
    function expandMenuItem(parentTitle, childTitle, childLevel) {
        const parentLink = document.querySelector(`a.tmenu_item_link[title="${parentTitle}"]`);
        if (parentLink) {
            const parentListItem = parentLink.closest('li.tmenu_item');
            if (childTitle) {
                // Use MutationObserver to wait for the child li to appear
                const observer = new MutationObserver(() => {
                    let childListItem;
                    if (childLevel !== undefined) {
                        // Find the correct li at the specified level and with the correct childTitle
                        childListItem = Array.from(parentListItem?.querySelectorAll(`li.tmenu_item_level_${childLevel}`) || [])
                            .find(li => {
                                const link = li.querySelector('a.tmenu_item_link');
                                return link && link.getAttribute('title') === childTitle;
                            });
                    } else {
                        const childLink = parentListItem?.querySelector(`a.tmenu_item_link[title="${childTitle}"]`);
                        childListItem = childLink?.closest('li.tmenu_item');
                    }
                    // Only add class if it doesn't already exist
                    if (childListItem && !childListItem.classList.contains('tmenu_item_active')) {
                        childListItem.classList.add('tmenu_item_active');
                        observer.disconnect();
                    } else if (childListItem) {
                        observer.disconnect();
                    }


                });
                observer.observe(parentListItem, { childList: true, subtree: true });
            }
        }
    }

    const menuSummary = document.querySelector('summary[aria-controls="menu-drawer"]');
    if (menuSummary) {
        menuSummary.addEventListener('click', () => {
            setTimeout(() => {
                expandMenuItem("Other Gifts", "Other Gifts", 1);
                expandMenuItem("Buy Bits", "Minifig parts");
            }, 5);
        });
    }
});
